<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<button type="button" data-toggle="tooltip" title="Отказ" class="btn btn-default" @click="$router.go(-1)"><i class="fa fa-times"></i></button>
					<button type="button" data-toggle="tooltip" title="Запис" class="btn btn-success" @click="onSubmit()"><i class="fa fa-save"></i></button>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content-->
	<div class="container-fluid" v-if="dataReady">

		<!-- Basic Info -->
		<div class="card col-12">
			<div class="card-block">

				<f-input v-model="link.title" name="link_title" v-validate="'required'" :errors="errorBag.collect('link_title')">
				</f-input>

				<f-textarea v-model="link.description" name="link_description" v-validate="'required'" :errors="errorBag.collect('link_description')">
				</f-textarea>

				<f-category v-model="link.categories" name="link_categories" v-validate="'required'" :errors="errorBag.collect('link_categories')">
				</f-category>

				<f-select v-model="link.language" name="link_language" v-validate="'required'" :errors="errorBag.collect('link_language')" :values="$config.lists.languages">
				</f-select>

				<f-input v-model="link.link" name="link_link" v-validate="'required'" :errors="errorBag.collect('link_link')">
				</f-input>

			</div>
			<!-- end card-block -->
		</div>
		<!-- end card -->
	</div>

</div>
</template>

<script>
module.exports = {
	props: ['resource'],
	data: function() {
		return {
			dataReady: true,
			link: {}
		};
	},
	created: function() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function() {
			if (!this.$route.params.id) {
				this.link = {
					title: '',
					description: '',
					categories: '',
					language: 'BG',
					link: ''
				};
				this.dataReady = true;
			} else {
				this.$http.get('backend://' + this.resource + '/' + this.$route.params.id).then((result) => {
					this.link = result.body;
					this.dataReady = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.putOrPostResource('backend://' + this.resource + '/', this.link).then((response) => {
					this.$router.push('/' + this.resource + '/' + response.body.id);
				}).catch(this.$http.toastCatcher);
			});
		}
	}
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// LinkResourceEdit.vue?56a781df